// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"xn","modify_order":"yn","modify_order_header":"zn","product_details_form_wrapper":"An","c_wrapper":"Bn","save_button":"Cn","title":"En","modify_order_title_wrapper":"Fn","note":"Gn","buttons_wrapper":"Hn"};
    if(module.hot) {
      // 1713211511808
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  